import React, { Component, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import "./Email.css"

const DraftEmail = function (props) {

    let editorState = props.editorState;
    let setEditorState = props.setEditorState;

    return (
        <Editor
            editorState={editorState}
            toolbarClassName="draft-email-toolbar"
            wrapperClassName="draft-email-wrapper"
            editorClassName="draft-email-editor"
            onEditorStateChange={setEditorState}
        />
    )

}

export { DraftEmail };